import { Box } from "@mui/system";
import BLDWebsiteDateFilter from "./BLDWebsiteContent/BLDWebsiteDateFilter";
import BLDWebsiteCategoryFilter from "./BLDWebsiteContent/BLDWebsiteCategoryFilter";
import BLDWebsiteTabs from "./BLDWebsiteContent/BLDWebsiteTabs";

const BLDWebsite = () => {
  return (
    <>
      <Box sx={{ px: 2 }}>
          <BLDWebsiteDateFilter/>
          <BLDWebsiteCategoryFilter/>
          <BLDWebsiteTabs/>
      </Box>
    </>
  ); 
};

export default BLDWebsite;
